// Version : 0.0.2
// Author : AGALYA
// LastEdit : SHIYAM
// Last ADD: imported types path properly
// MODFIED DATE : 05-08-2025

import PurposeOfLoanActionTypes from './purpose-of-loan.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	addPurposeOfLoanDetailsResponse: null,
	updatePurposeOfLoanDetailsResponse: null,
	getPurposeOfLoanListResponse: null,
	getPurposeOfLoanListArr: [],
	fetchPurposeOfLoanDetailsResponse: null,
	fetchPurposeOfLoanDetailsArr: [],
	deletePurposeOfLoanDetailsResponse: null,
	updatePurposeOfLoanPublishStatusResponse: null,
};

const purposeofLoanReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** ADD PURPOSE OF LOAN DETAILS START *********************** */
		case PurposeOfLoanActionTypes.ADD_PURPOSE_OF_LOAN_DETAILS_SUCCESS:
			return { ...state, addPurposeOfLoanDetailsResponse: action.payload };

		case PurposeOfLoanActionTypes.ADD_PURPOSE_OF_LOAN_DETAILS_FAILURE:
			return { ...state, addPurposeOfLoanDetailsResponse: action.payload };

		case PurposeOfLoanActionTypes.ADD_PURPOSE_OF_LOAN_DETAILS_RESPONSE_CHANGED:
			return { ...state, addPurposeOfLoanDetailsResponse: null };
		/** ***************** ADD PURPOSE OF LOAN DETAILS END *********************** */

		/** ***************** UPDATE PURPOSE OF LOAN DETAILS START *********************** */
		case PurposeOfLoanActionTypes.UPDATE_PURPOSE_OF_LOAN_DETAILS_SUCCESS:
			return { ...state, updatePurposeOfLoanDetailsResponse: action.payload };

		case PurposeOfLoanActionTypes.UPDATE_PURPOSE_OF_LOAN_DETAILS_FAILURE:
			return { ...state, updatePurposeOfLoanDetailsResponse: action.payload };

		case PurposeOfLoanActionTypes.UPDATE_PURPOSE_OF_LOAN_DETAILS_RESPONSE_CHANGED:
			return { ...state, updatePurposeOfLoanDetailsResponse: null };
		/** ***************** UPDATE PURPOSE OF LOAN DETAILS END *********************** */

		/** ***************** GET PURPOSE OF LOAN DETAILS START *********************** */
		case PurposeOfLoanActionTypes.GET_PURPOSE_OF_LOAN_LIST_SUCCESS:
			return {
				...state,
				getPurposeOfLoanListResponse: action.payload,
				getPurposeOfLoanListArr: docodeHexResponse(
					action.payload,
					'GetPurposeOfLoanListKey',
				),
			};

		case PurposeOfLoanActionTypes.GET_PURPOSE_OF_LOAN_LIST_FAILURE:
			return { ...state, getPurposeOfLoanListResponse: action.payload };

		case PurposeOfLoanActionTypes.GET_PURPOSE_OF_LOAN_LIST_RESPONSE_CHANGED:
			return { ...state, getPurposeOfLoanListResponse: null };
		/** ***************** GET PURPOSE OF LOAN DETAILS END *********************** */

		/** ***************** FETCH PURPOSE OF LOAN DETAILS START *********************** */
		case PurposeOfLoanActionTypes.FETCH_PURPOSE_OF_LOAN_DETAILS_SUCCESS:
			return {
				...state,
				fetchPurposeOfLoanDetailsResponse: action.payload,
				fetchPurposeOfLoanDetailsArr: docodeHexResponse(
					action.payload,
					'FetchPurposeOfLoanDetailsKey',
				),
			};

		case PurposeOfLoanActionTypes.FETCH_PURPOSE_OF_LOAN_DETAILS_FAILURE:
			return { ...state, fetchPurposeOfLoanDetailsResponse: action.payload };

		case PurposeOfLoanActionTypes.FETCH_PURPOSE_OF_LOAN_DETAILS_RESPONSE_CHANGED:
			return {
				...state,
				fetchPurposeOfLoanDetailsResponse: null,
				fetchPurposeOfLoanDetailsArr: [],
			};
		/** ***************** FETCH PURPOSE OF LOAN DETAILS END *********************** */

		/** ***************** DELETE PURPOSE OF LOAN DETAILS START *********************** */
		case PurposeOfLoanActionTypes.DELETE_PURPOSE_OF_LOAN_DETAILS_SUCCESS:
			return { ...state, deletePurposeOfLoanDetailsResponse: action.payload };

		case PurposeOfLoanActionTypes.DELETE_PURPOSE_OF_LOAN_DETAILS_FAILURE:
			return { ...state, deletePurposeOfLoanDetailsResponse: action.payload };

		case PurposeOfLoanActionTypes.DELETE_PURPOSE_OF_LOAN_DETAILS_RESPONSE_CHANGED:
			return { ...state, deletePurposeOfLoanDetailsResponse: null };
		/** ***************** DELETE PURPOSE OF LOAN DETAILS END *********************** */

		/** ***************** UPDATE PURPOSE OF LOAN PUBLISH STATUS START *********************** */
		case PurposeOfLoanActionTypes.UPDATE_PURPOSE_OF_LOAN_PUBLISH_STATUS_SUCCESS:
			return { ...state, updatePurposeOfLoanPublishStatusResponse: action.payload };

		case PurposeOfLoanActionTypes.UPDATE_PURPOSE_OF_LOAN_PUBLISH_STATUS_FAILURE:
			return { ...state, updatePurposeOfLoanPublishStatusResponse: action.payload };

		case PurposeOfLoanActionTypes.UPDATE_PURPOSE_OF_LOAN_PUBLISH_STATUS_RESPONSE_CHANGED:
			return { ...state, updatePurposeOfLoanPublishStatusResponse: null };
		/** ***************** UPDATE PURPOSE OF LOAN PUBLISH STATUS END *********************** */

		default:
			return state;
	}
};

export default purposeofLoanReducer;
